import { render } from "./LegacyMagicFields.vue?vue&type=template&id=9447bf4c"
import script from "./LegacyMagicFields.vue?vue&type=script&lang=js"
export * from "./LegacyMagicFields.vue?vue&type=script&lang=js"
script.render = render

export default script